export const monthsKeys = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export const fullDateFormat = 'DD.MM.yyyy';
export const fullDateFormatTimestamp = 'YYYY-MM-DD';

// CALENDAR
export const calendarStartHour: string = '07:00';
export const calendarEndHour: string = '17:00';

export const CALENDAR_DATE_FORMAT = 'DD.MM.yyyy';

// USER SETTINGS
export const DATA_LISTING_REQUEST_PROCESSING_BUSINESS_DAYS = 5;
export const DATA_LISTING_REQUEST_COOLDOWN_BUSINESS_DAYS = 10;

// FONTS
export enum FontSize {
  SMALL = 'F_SM',
  MEDIUM = 'F_M',
  LARGE = 'F_L',
}

export const FontSizeToPx = {
  [FontSize.SMALL]: '0px',
  [FontSize.MEDIUM]: '2px',
  [FontSize.LARGE]: '4px',
};
